module.exports = __webpack_public_path__ + "img/logo-google.55b5f1ac.svg";